export const colorOptions = [
  { key: 'red', hex: '#CA2D20' },
  { key: 'darkgreen', hex: '#004d00' },
  { key: 'blue', hex: '#5063D9' },
  { key: 'purple', hex: '#964BBC' },
  { key: 'orange', hex: '#ED6E2E' },
  { key: 'green', hex: '#58B539' },
  { key: 'lightblue', hex: '#00BFFF' },
  { key: 'lightpurple', hex: '#C88CE8' },
  { key: 'yellow', hex: '#FBF451' },
  { key: 'limegreen', hex: '#7FFF00' },
  { key: 'turquoise', hex: '#40E0D0' },
  { key: 'pink', hex: '#DC3183' },
  { key: 'black', hex: '#000000' },
  { key: 'grey', hex: '#999999' },
  { key: 'lightgrey', hex: '#D9D9D9' },
  { key: 'white', hex: '#FFFFFF' },
  { key: 'none', label: 'Remove colour', hex: null },
];
